import React from "react";
import SettingsPage from "./SettingsPage";

const SettingsModule = () => {
  return <SettingsPage />;
};

export default SettingsModule;
